import React, { Component } from 'react';
import { Area, AreaChart, ResponsiveContainer } from "recharts";
import { fade, darken } from '@material-ui/core/styles';


class BackGroupChart extends Component {
    randomDataArray() {
        var data_bar = [];
        for (var i = 0; i < 5; i++) {
            console.log({
                name: "core " + i,
                pv: Math.round(Math.random() * 60)
              })
          data_bar.push({
            name: "core " + i,
            pv: Math.round(Math.random() * 60)
          });
        }
        return data_bar;
      }
      constructor(props) {
        super(props);
        this.state = {
          increamentData1: this.randomDataArray()
        };
      }
      intervalID = null
      componentDidMount=()=>{
        this.intervalID = setInterval(
            ()=>
                this.tick()
            ,
            30000
        )
      }
      tick() {
        this.setState({
            increamentData1: this.randomDataArray()
        });
      }
      componentWillUnmount() {
        clearInterval(this.intervalID);
    }
    render() {
        console.log(this.props.BackGroudColor,'bbbbb')
        return (
            <>
              <ResponsiveContainer width="100%" height={this.props.height}>
                                <AreaChart
                                    data={
                                        this.state.increamentData1
                                    }
                                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                                    >
                                    <Area
                                        dataKey="pv"
                                        strokeWidth={0}
                                        type="monotone"
                                        stackId="2"
                                        stroke="#44D1C2"
                                        fill={this.props.BackGroudColor ? darken(this.props.BackGroudColor, 0.2) : "#fff"}
                                        // fill="#44D1C2"
                                    />
                                </AreaChart>
                            </ResponsiveContainer>  
            </>
        );
    }
}

export default (BackGroupChart);